import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { Activity } from '@wilson/interfaces';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { PriorityHelperService } from '../service/priority-tag-helper.service';

export interface ChangePriorityModalInputData {
  activities: Activity[];
  description: string;
}
@Component({
  selector: 'wilson-change-priority-modal',
  templateUrl: './change-priority-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChangePriorityModalComponent implements OnInit {
  private data = inject<ChangePriorityModalInputData>(NZ_MODAL_DATA);
  private priorityHelperService = inject(PriorityHelperService);

  public priority?: number | null;
  public priorities!: number[];
  public description!: string;

  ngOnInit(): void {
    this.description = this.data.description;
    this.priority = this.data.activities[0].priority;
    this.priorities = this.priorityHelperService.getPriorities();
  }
}
